import type { DownloadJobType } from "@volgo/core/contract";
import { useEffect } from "react";
import { useServerBlocks } from "../policy/blocked";

export interface GalleryInfo {
  title: string | null;
  verdict: "unknown" | "open" | "blocked";
}

/** Each job response carries the server's current title and policy, including completion polls. */
export function useGalleryInfo(jobs: readonly DownloadJobType[]): (job: DownloadJobType) => GalleryInfo {
  const blocks = useServerBlocks();
  const noteBlocked = blocks.note;
  useEffect(() => {
    for (const job of jobs) {
      if (job.galleryPolicy === "block" || job.errorCode === "POLICY_BLOCKED") noteBlocked(job.gid);
    }
  }, [jobs, noteBlocked]);
  return (job) => ({
    title: job.galleryTitle ?? null,
    verdict:
      blocks.isBlocked(job.gid) || job.galleryPolicy === "block" || job.errorCode === "POLICY_BLOCKED"
        ? "blocked"
        : job.galleryPolicy === "none" || job.galleryPolicy === "warn"
          ? "open"
          : "unknown",
  });
}
